{
  "users": {
    "title": "إدارة المستخدمين",
    "add": "إضافة مستخدم",
    "columns": {
      "name": "الاسم",
      "username": "اسم المستخدم",
      "email": "البريد الإلكتروني",
      "group": "المجموعة",
      "branches": "الفروع",
      "status": "الحالة",
      "lastLogin": "آخر تسجيل دخول"
    },
    "neverLoggedIn": "لم يسجل الدخول مطلقا",
    "filters": {
      "status": "الحالة",
      "group": "المجموعة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}"
    },
    "drawer": {
      "createTitle": "إضافة مستخدم",
      "editTitle": "تعديل المستخدم",
      "createDescription": "ابحث عن موظف موجود باسم المستخدم، أو أنشئ موظفا جديدا.",
      "editDescription": "تحديث بيانات هذا المستخدم.",
      "usernameSearch": "البحث باسم المستخدم",
      "usernameSearchPlaceholder": "اسم مستخدم الموظف",
      "search": "بحث",
      "foundEmployee": "تم العثور على موظف موجود",
      "useNewEmployee": "إنشاء موظف جديد بدلا من ذلك",
      "fields": {
        "nameAr": "الاسم بالعربية",
        "nameEn": "الاسم بالإنجليزية",
        "username": "اسم المستخدم",
        "email": "البريد الإلكتروني",
        "phone": "الهاتف",
        "nfcId": "معرف NFC",
        "group": "المجموعة",
        "branches": "الفروع"
      },
      "created": "تم إنشاء المستخدم بنجاح",
      "updated": "تم تحديث المستخدم بنجاح"
    },
    "resetPassword": {
      "title": "إعادة تعيين كلمة المرور",
      "emailedDescription": "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريد هذا المستخدم.",
      "linkDescription": "لا يوجد بريد إلكتروني مسجل لهذا المستخدم. شارك هذا الرابط لمرة واحدة معه مباشرة:",
      "close": "إغلاق"
    },
    "setupLink": {
      "title": "رابط إكمال التسجيل",
      "emailedDescription": "تم إرسال رابط إكمال التسجيل بالبريد",
      "linkDescription": "لا يوجد بريد إلكتروني مسجل لهذا المستخدم. شارك هذا الرابط لمرة واحدة معه مباشرة:",
      "close": "إغلاق"
    },
    "statusConfirmTitle": "تغيير حالة هذا المستخدم؟",
    "deleteConfirmTitle": "حذف هذا المستخدم؟",
    "deleteConfirmDescription": "سيفقد {{name}} الوصول إلى نظام العملاء. حساب الموظف المشترك غير متأثر.",
    "resetPasswordConfirmTitle": "إعادة تعيين كلمة مرور هذا المستخدم؟",
    "resetPasswordConfirmDescription": "سيحتاج {{name}} لتعيين كلمة مرور جديدة لتسجيل الدخول من جديد.",
    "deleted": "تم حذف المستخدم بنجاح",
    "statusChanged": "تم تغيير حالة المستخدم بنجاح",
    "passwordReset": "تم إعادة تعيين كلمة المرور بنجاح"
  },
  "groups": {
    "title": "إدارة المجموعات",
    "add": "إضافة مجموعة",
    "columns": {
      "name": "الاسم",
      "description": "الوصف",
      "users": "المستخدمين",
      "services": "الخدمات",
      "status": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}",
      "assignServices": "تعيين الخدمات"
    },
    "drawer": {
      "createTitle": "إضافة مجموعة",
      "editTitle": "تعديل المجموعة",
      "createDescription": "أنشئ مجموعة لتحديد خدمات مستخدميها.",
      "editDescription": "تحديث بيانات هذه المجموعة.",
      "fields": {
        "nameAr": "الاسم بالعربية",
        "nameEn": "الاسم بالإنجليزية",
        "descriptionAr": "الوصف بالعربية",
        "descriptionEn": "الوصف بالإنجليزية"
      },
      "created": "تم إنشاء المجموعة بنجاح",
      "updated": "تم تحديث المجموعة بنجاح"
    },
    "statusConfirmTitle": "تغيير حالة هذه المجموعة؟",
    "deleteConfirmTitle": "حذف هذه المجموعة؟",
    "deleteConfirmDescription": "سيتم حذف {{name}} نهائيا. لا يمكن التراجع عن هذا الإجراء.",
    "systemGroupProtected": "لا يمكن تغيير مجموعة مدير النظام",
    "deleted": "تم حذف المجموعة بنجاح",
    "statusChanged": "تم تغيير حالة المجموعة بنجاح"
  },
  "services": {
    "title": "تعيين الخدمات",
    "description": "اختر الخدمات التي يمكن لمستخدمي هذه المجموعة تنفيذها.",
    "selectAll": "تحديد الكل",
    "deselectAll": "إلغاء تحديد الكل",
    "search": "البحث في الخدمات",
    "save": "حفظ",
    "saved": "تم حفظ الصلاحيات بنجاح",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "ستفقد تغييرات الخدمات غير المحفوظة.",
    "unsavedChanges": "لديك تغييرات غير محفوظة"
  },
  "customerSettings": {
    "title": "إعدادات العملاء",
    "phoneVerification": "تأكيد رقم الهاتف برمز واتساب",
    "phoneVerificationHelp": "يرسل رمز عبر واتساب عند إضافة عميل أو تغيير رقم الهاتف. ولا يتم الحفظ إلا بعد إدخال الرمز.",
    "saved": "تم تحديث إعدادات العملاء بنجاح"
  }
}
